export const defaultAction = {
    RESET: undefined,
    PENDING: undefined,
    REJECTED: undefined,
    FULFILLED: undefined,
};